// src/components/ContributionBasisNote.js
//
// PRD_PhilHealthContributionBasis H11 — the dormant-field note, shared by the
// three surfaces that render a stored government-contribution figure.
//
// WHAT IT SAYS: when a company composes an agency's contribution basis from
// actual pay, payroll stops reading that employee's stored figure and uses the
// composed amount instead (PRD_SssContributionBasis C17). The stored field is
// DORMANT, not dead — turn the basis off and it is the live target again — so
// it stays editable and required, and keeps its suggestion chip.
//
// EXTRACTED, NOT INVENTED: the sentence is C14's locked wording from
// StepEmployment. What is new is that it takes the agency rather than
// hard-coding SSS, so the same sentence renders on the wizard's Employment and
// Review steps and on EmployeeDetail — the two surfaces C14 left un-annotated.
//
// H11a — NO LINK, on any surface. C14 linked "Settings → Pay Rates" with
// target=_blank, reasoning that a same-tab hop would lose a half-filled wizard.
// Both halves were withdrawn at /test-impl:
//   * The note is informational, not a call to action. It says the field in
//     front of you is dormant; nothing needs changing right now.
//   * A new tab makes it WORSE. Every surface reads settings/payrollRates once
//     in a mount-time effect, so changing the basis in the opened tab and
//     switching back shows the stale note until a reload.
//   * It was the only new-tab link from inside the signed-in workspace to
//     another workspace page. The app's other target=_blank links either leave
//     it entirely (the Discovery booking URL, the kiosk app's own domain, a
//     Stripe-hosted invoice) or open a static reference page from the signed-out
//     signup form (/terms, /privacy) — those are in-app routes, but nothing on
//     the form depends on their contents, so they cannot go stale against it.
// The path stays in the prose, so a reader who does want to change it knows
// where to go.

import React from "react";

// `agencies` is a LIST, not a pre-joined string, so the verb can agree with it.
// Passing "SSS and PhilHealth" as one string reads "…and PhilHealth IS computed
// from…", which is the same class of defect as a count label with no singular
// form — it only shows up on the two-agency path, which is the rarer one.
const ContributionBasisNote = ({ agencies }) => {
  const list = Array.isArray(agencies) ? agencies : [agencies];
  return (
    <p
      style={{
        margin: "6px 0 0",
        fontSize: "0.75rem",
        lineHeight: 1.4,
        color: "var(--ui-text-muted)",
      }}
    >
      Not used for payroll while contribution basis is on — {list.join(" and ")}{" "}
      {list.length > 1 ? "are" : "is"} computed from Settings → Pay Rates.
    </p>
  );
};

export default ContributionBasisNote;
